import { CModal, CModalHeader, CModalBody, CModalFooter, CButton } from '@coreui/react'
import styles from './WorkerModal.module.scss'
import { QRCodeSVG } from 'qrcode.react';
import dayjs from 'dayjs';

export default function WorkerModal({ onClose, dataState, workerProfessions, selectedOption }) {
   // console.log('workerProfessions', workerProfessions)
   // console.log('dataSate', dataState)

   const now = dayjs();

   const sortedProfessions = [...workerProfessions].sort((a, b) => {
      const aVerified = a.workerProffesionDocs?.length > 0 &&
         a.workerProffesionDocs[a.workerProffesionDocs.length - 1].status === 'verified';
      const bVerified = b.workerProffesionDocs?.length > 0 &&
         b.workerProffesionDocs[b.workerProffesionDocs.length - 1].status === 'verified';


      if (aVerified && !bVerified) return -1;
      if (!aVerified && bVerified) return 1;
      return 0;
   });
   return (
      <div className={styles.modal}>
         <div className={styles.content}>
            {/* <CModalHeader >
             
            </CModalHeader> */}

            <CModalBody style={{ flexGrow: 1, overflowY: 'auto', padding: '20px', position: 'relative' }} className={styles.main}>
               <button
                  className={styles.closeButton}
                  onClick={onClose}
                  style={{
                     position: 'absolute',
                     top: '10px',
                     right: '10px',
                     background: 'transparent',
                     border: 'none',
                     fontSize: '24px',
                     cursor: 'pointer',
                     color: '#000',
                  }}
               >
                  ✕
               </button>
               <div className={styles.left}>
                  <div className={styles.cardMain}>
                     <h2 >Працівник</h2>
                     <h2>Worker</h2>
                     <img className={styles.workerImg} alt='photo' src={`${process.env.REACT_APP_SERVER_URL}/${dataState?.photo?.contentUrl}`} />
                     <h2 className={styles.workerName}>
                        {/* Іваненко Іван Іванович */}
                        {dataState.fullName}
                     </h2>
                     <h3 className={styles.orgTitle}>
                        {/* ТОВ 'Будмонтаж' */}
                        {selectedOption.label}
                     </h3>
                  </div>
                  <div className={styles.cardFooter}>
                     <div className={styles.cardFooter__left} >
                        <QRCodeSVG
                           // value="https://example.com"
                           value={`${process.env.REACT_APP_SITE_URL}/workers/update/${dataState.id}`}
                           // size={256} 

                           className={styles.qr}
                        />
                     </div>
                     <div className={styles.cardFooter__right}>
                        <h2 className={styles.mainJob}>
                           {/* Зварювальник */}
                           {dataState.position}
                        </h2>
                        <h3 className={styles.cardFooterCode}>
                           {`№ картки ${dataState.code1c || '-'}`}
                        </h3>
                     </div>
                  </div>
               </div>
               <div className={styles.left}>
                  <div className={styles.cardMain}>
                     <h2 className={styles.cardMain__right}
                     //  style={{ fontSize: workerProfessions.length < 9 ? '40px' : '30px' }}
                     >Навчання</h2>
                     <h2 className={styles.cardMain__right}
                     // style={{ fontSize: workerProfessions.length < 9 ? '40px' : '30px' }}
                     >Training</h2>
                     {/* <div className={styles.studiing}>
                        <div className={styles.studiing__block}>
                           <h3>Зварювальник</h3>
                           <span>✔</span>
                        </div>

                        <div className={styles.studiing__block}>
                           <h3>Стропальник</h3>
                           <span>❌</span>
                        </div>
                        <div className={styles.studiing__block}>
                           <h3>Стропальник</h3>
                           <span>❌</span>
                        </div>
                        <div className={styles.studiing__block}>
                           <h3>Стропальник</h3>
                           <span>❌</span>
                        </div>
                        <div className={styles.studiing__block}>
                           <h3>Стропальник</h3>
                           <span>❌</span>
                        </div>
                     </div> */}
                     <div className={styles.studiing}>
                        {
                           // workerProfessions.
                           sortedProfessions.
                              map(elem => {
                                 return (
                                    <div className={styles.studiing__block}>
                                       <h3
                                          // style={{ fontSize: workerProfessions.length < 9 ? '35px' : '20px' }}
                                          className={workerProfessions.length < 9 ? styles.fontLarge : styles.fontSmall}
                                       >
                                          {elem.workerProffessionList.name}
                                       </h3>
                                       <span
                                          style={{
                                             fontSize:
                                                workerProfessions.length < 9 ? '25px' : '10px'
                                          }}
                                       >
                                          {elem.workerProffesionDocs?.length > 0
                                             ? elem.workerProffesionDocs[elem.workerProffesionDocs.length - 1].status === 'verified'
                                                ? <svg
                                                   xmlns="http://www.w3.org/2000/svg"
                                                   width={workerProfessions.length < 9 ? 25 : 15}
                                                   height={workerProfessions.length < 9 ? 25 : 15}
                                                   viewBox="0 0 24 24"
                                                   fill="none"
                                                   stroke="green"
                                                   strokeWidth="3"
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                >
                                                   <polyline points="20 6 9 17 4 12" />
                                                </svg>

                                                : <svg
                                                   xmlns="http://www.w3.org/2000/svg"
                                                   width={workerProfessions.length < 9 ? 25 : 15}
                                                   height={workerProfessions.length < 9 ? 25 : 15}
                                                   viewBox="0 0 24 24"
                                                   fill="none"
                                                   stroke="red"
                                                   strokeWidth="3"
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                >
                                                   <line x1="18" y1="6" x2="6" y2="18" />
                                                   <line x1="6" y1="6" x2="18" y2="18" />
                                                </svg>

                                             : <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={workerProfessions.length < 9 ? 25 : 15}
                                                height={workerProfessions.length < 9 ? 25 : 15}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="red"
                                                strokeWidth="3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                             >
                                                <line x1="18" y1="6" x2="6" y2="18" />
                                                <line x1="6" y1="6" x2="18" y2="18" />
                                             </svg>


                                          }
                                       </span>
                                    </div>
                                 )
                              })
                        }
                     </div>
                  </div>
                  <div className={styles.cardFooter}>

                     <div className={styles.cardFooter__date}>
                        <h3> Дата формування:<br />{dayjs().format('YYYY-MM-DD')}</h3>
                     </div>
                  </div>
               </div>

            </CModalBody>

            {/* <CModalFooter
               className={styles.footer}>
               <CButton color="secondary" onClick={onClose}>Закрити</CButton>

            </CModalFooter> */}
         </div>
      </div>
   )
}
